// This file allows you to configure ESLint according to your project's needs, so that you
// can control the strictness of the linter, the plugins to use, and more.

// For more information about configuring ESLint, visit https://eslint.org/docs/user-guide/configuring/

import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next"
import { Button } from "antd"

export default function QrScanner2({ onScan }) {
    const [error, setError] = useState("");
    const [preview, setPreview] = useState(null);
    const fileInputRef = useRef(null);
    const { t } = useTranslation()

    const handleImage = async (event) => {
        const file = event.target.files?.[0];

        if (!file) {
            return;
        }

        try {
            setPreview(URL.createObjectURL(file));

            if (!("BarcodeDetector" in window)) {
                throw new Error("BarcodeDetector not supported");
            }

            const detector = new window.BarcodeDetector({
                formats: ["qr_code"],
            });

            const bitmap = await createImageBitmap(file);

            const results = await detector.detect(bitmap);

            if (results.length > 0) {
                onScan(results[0].rawValue);
            } else {
                setError("No QR code found in image");
            }
        } catch (err) {
            setError(err.message);
        }
    };



    return (
        <>
            <Button
                onClick={() => fileInputRef.current?.click()}
                style={{ width:"125px", marginLeft:"calc(50% - 62px)", marginBottom:"30px" }}
            >{t("page.newcard.modal.QRButton")}</Button>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleImage}
                style={{ display: "none" }}
            />

            {error && <div>{error}</div>}
        </>
    );
}